import React, { useEffect, useRef } from 'react';

import {
  InfiniteScrollItemWrapperDefaultProps,
  InfiniteScrollItemWrapperPropTypes,
} from '@/ebat/components/blocks/Products/InfiniteScrollItemWrapper/InfiniteScrollItemWrapper.proptypes';

const InfiniteScrollItemWrapper = ({
  children,
  className,
  context,
  page,
  sku,
  wrapperObserver,
}) => {
  const ref = useRef();

  useEffect(() => {
    if (page && wrapperObserver && ref.current) {
      const wrapperElement = ref.current;
      wrapperElement.page = page;
      wrapperObserver.observe(wrapperElement);
      return () => {
        wrapperObserver.unobserve(wrapperElement);
      };
    }

    return () => {};
  }, [page, wrapperObserver]);

  return (
    <li
      ref={ref}
      className={className}
      data-qa-id={context}
      data-qa-item-sku={sku}
    >
      {children}
    </li>
  );
};

InfiniteScrollItemWrapper.defaultProps = {
  ...InfiniteScrollItemWrapperDefaultProps,
};

InfiniteScrollItemWrapper.propTypes = {
  ...InfiniteScrollItemWrapperPropTypes,
};

export default InfiniteScrollItemWrapper;
